import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {DialogService} from '../../../../../services/dialog/dialog.service';

@Component({
    selector: 'app-conversion-adjust-payout',
    imports: [
        ReactiveFormsModule
    ],
    templateUrl: './conversion-adjust-payout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './conversion-adjust-payout.component.scss'
})
export class ConversionAdjustPayoutComponent implements Dialog {
    form = new FormGroup({
        payout: new FormControl<number>(0),
    });

    constructor(
        private dialogService: DialogService,
    ) {
    }

    onDialogInit(params: DialogParams): void {
    }

    onSubmit(): void {
        let payoutText = this.form.get('payout')?.value?.toString() ?? '';
        let payout = parseFloat(payoutText.replaceAll(',', '.'));

        if (payout && payout > 0) {
            // Convert to cents
            payout = Math.round(payout * 100);
        } else {
            payout = 0;
        }

        this.dialogService.closeDialog({
            payout: payout,
        })
    }
}
